import React, { ReactElement } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { LinkButton } from '../linkButton';
import { SxTooltip } from '../utils/wrapComponents';
import { colors } from '../../../styles/variables';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { isNetquestClient } from '../../../utils/clients';

import styles from './invoiceDealInstructions.module.scss';

interface IProps {
  instructions?: ReactElement;
}

export const CannotFindDealInstructions = ({ instructions }: IProps): ReactElement => {
  if (isFeatureEnabled(Features.CreditPoolExtension) && isNetquestClient() && instructions) {
    return (
      <div className={styles.instructions}>
        <SxTooltip
          Component={(
            <label className={styles.link}>
              <span className={styles.label}>I can't find my deal</span>
              <QuestionCircleOutlined style={{ color: colors.sightxPurple400 }}/>
            </label>
          )}
          tooltipText={instructions}
        />
      </div>
    );
  }

  const href = 'https://www.notion.so/sightx/Deals-in-the-Invoice-Hub-af6cfd5f56d14c4c9882e48e2a7decf7';
  return (
    <div className={styles.instructions}>
      <LinkButton className={styles.link} href={href} target='_blank'>
        <span className={styles.text}>I can't find my deal</span>
        <QuestionCircleOutlined style={{ color: colors.sightxPurple400 }}/>
      </LinkButton>
    </div>
  );
};
